export default __webpack_public_path__ + "static/media/H1018.4.6bb368b3.mp3";